module.exports = __webpack_public_path__ + "static/img/img-home-cup-iouticons.b72cada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-cup-iouticons.png
// module id = ay/F
// module chunks = 1